import React from 'react';

import classnames from 'classnames';
import PropTypes from 'prop-types';

ColumnPickerField.propTypes = {
    column: PropTypes.shape({
        name: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        selected: PropTypes.bool,
        subtitle: PropTypes.string,
    }),
    onSelect: PropTypes.func.isRequired,

    /**
     * Boolean value on whether to display the column.subtitle string. One
     * example is that we only want to show the subtitle if we're searching,
     * because at time of writing the subtitle was always the same info as the
     * bucket.
     */
    showSubtitle: PropTypes.bool,
};

export function ColumnPickerField({column, onSelect, showSubtitle}) {
    const subtitle = column.subtitle;
    const classes = classnames({
        'ui-row': true,
        'ui-row__field': true,
        'ui-row--selected': column.selected,
        'ui-row--selectable': column.name !== 'name',
    });

    return (
        <li className={classes} onClick={onSelect}>
            {column.name !== 'name' ? (
                <input
                    type='checkbox'
                    className='ui-field-checkbox'
                    checked={column.selected}
                    onChange={() => {}}
                /> // Fugly but fixes propType warning
            ) : undefined}
            <span className='ui-field-name'>{column.title}</span>
            {showSubtitle ? <span className='ui-field-subtitle'>{subtitle}</span> : undefined}
        </li>
    );
}
